import React from "react";
import classes from "./JourneyProgress.module.scss";

interface Props {
  progress: "complete" | "current" | "incomplete";
  children: React.ReactNode;
  first?: boolean;
}

function JourneyStep({ progress, children, first = false }: Props) {
  const commonClasses = [
    classes.journeyStep,
    classes[progress],
    first ? classes.first : null,
  ].join(" ");

  return (
    <div className={commonClasses}>
      <div className={classes.label}>{children}</div>
      <div className={classes.bar}></div>
    </div>
  );
}

export default JourneyStep;
